import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <section className="mb-3">
      <div className="container">
        <div className="row d-flex align-items-center my-2 my-md-5 my-div mb-5">
          <div class="col-sm-6">
            <div className="h3">
              Chez MooviCar, renforcer le lien de confiance qui nous lie à nos utilisateurs est au
              coeur de nos préoccupations
            </div>
            <hr
              style={{
                border: '2px solid #ff6600',
                width: '50%',
                margin: '20px 0', // Pas de margin auto pour éviter la centration
                marginLeft: '0', // Positionnement à gauche
                opacity: 1, // Opacité à 100%
              }}
            />{' '}
          </div>

          <div class="col-sm-6">
            <p>
              Tout comme notre application permet d’utiliser une voiture en toute simplicité, nous
              pensons qu'il devrait être facile de comprendre comment et pourquoi nous utilisons les
              informations que vous partagez avec nous. Cette page vise à vous fournir les
              informations nécessaire pour comprendre comment nous collectons, utilisons et
              protégeons vos données. Pour plus d’informations :
            </p>
            <div class="d-flex justify-content-end py-2">
              <Link className="me-2 text-white btn btn-lg" to="/signin">
                Politique de confidentialité
              </Link>
              <Link className="btn btn btn-outline-lg mb-2" to="/location-voiture">
                Cookies <i class="bi bi-arrow-right-circle h5"></i>
              </Link>
            </div>
          </div>
        </div>
        <div class="text-center mb-3 mb-3 h6">
          Une approche des données construite autour de 4 piliers
        </div>
        <hr
          style={{
            border: '2px solid #ff6600',
            width: '20%',
            margin: 'auto', // Pas de margin auto pour éviter la centration
            opacity: 1, // Opacité à 100%
          }}
        />{' '}
        <div className="row d-flex align-items-center my-2 my-md-5 p-5 mb-5">
          <div class="col-sm-6">
            <h3> Nous gardons vos données sécurisées </h3>
            <p className="mb-3">
              Lorsque vous utilisez Moovicar, vous nous confiez vos données. Nos équipes travaillent
              24h / 24 pour le protéger contre la fraude, les abus et les accès non autorisés. Nous
              avons également mis en place des règles strictes pour nous assurer que seul le strict
              minimum d'employés a accès aux informations de base dont ils ont besoin pour faire
              leur travail. Enfin, nous nous sommes engagés à ne pas vendre vos données.
            </p>

            <h3> Nous utilisons des données pour améliorer votre expérience</h3>
            <p className="mb-3">
              Nous travaillons tous les jours chez Moovicar pour nous assurer que notre service
              répond à vos besoins. Nous utilisons les données pour améliorer notre site Web et
              notre application ou pour développer de nouvelles fonctionnalités et de nouveaux
              outils adaptés à vos attentes. Nous stockons certaines informations pour vous éviter
              de devoir les saisir à chaque fois que vous utilisez Moovicar. Et nous utilisons votre
              géolocalisation pour vous aider à trouver les voitures Moovicar autour de vous.
            </p>
          </div>
          <div class="col-sm-6">
            <h3> Nous renforçons la confiance au sein de notre communauté </h3>
            <p className="mb-3">
              Lorsque vous allez sur Moovicar, vous voulez être sûrs d’ interagir uniquement avec
              des conducteurs dignes de confiance et de trouver des voitures sûres. Nous avons
              appris à évaluer instantanément des centaines de signaux qui nous aident à anticiper
              et enquêter sur les activités suspectes. Par exemple, nous vérifions automatiquement
              les documents d'identité et les permis de conduire pour les locations Moovicar Connect
              pour empêcher les fraudeurs d’intégrer notre communauté.
            </p>

            <h3> Nous vous fournissons les outils nécessaires pour contrôler vos données </h3>
            <p className="mb-3">
              Grâce aux paramètres de votre compte Moovicar ou de votre navigateur, vous pouvez
              modifier vos informations personnelles ou personnaliser vos préférences de cookies à
              tout moment. Nous avons également mis en place une adresse e-mail dédiée dans le cas
              où vous souhaitez nous poser des questions sur notre politique de protection des
              données personnelles ou si vous souhaitez accéder à, modifier ou supprimer vos données
              personnelles.
            </p>
          </div>
        </div>
        <h2> Nos réponses à vos questions </h2>
        <div>
          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Qu'est-ce que MooviCar considère comme des données personnelles ?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Chez MooviCar, nous utilisons la même définition que le RGPD pour déterminer
                    quelles données doivent être considérées comme des données personnelles. Le
                    terme « Données à caractère personnel » couvre toute information permettant
                    d’identifier de manière directe ou indirecte une personne physique. Il peut par
                    exemple s’agir d’un nom, d’une adresse, d’un numéro de téléphone, d’un e-mail,
                    mais également de données comme les adresses IP.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Quelles informations sont collectées par MooviCar ?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    MooviCar collecte des informations non seulement pour faire fonctionner son
                    service mais aussi pour l’améliorer au quotidien. Ces données, comme les
                    informations de votre compte ou votre localisation, sont essentielles pour
                    connecter les locataires et les propriétaires de la plateforme.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Pourquoi MooviCar demande mes papiers d'identité ou mon permis de conduire ?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Nous vérifions automatiquement les documents d'identité et les permis de
                    conduire pour que notre assurance couvre bien les locations, mais aussi pour
                    détecter et empêcher les activités frauduleuses.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Est-ce que MooviCar partage mes informations personnelles ?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Certains services et fonctionnalités de MooviCar partagent des données avec des
                    tiers pour fonctionner correctement, comme lors d'une réservation où certaines
                    informations sont partagées avec le propriétaire du véhicule.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Comment MooviCar protège mes données ?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Chez MooviCar, la sécurité des données de nos utilisateurs est une priorité.
                    Nous utilisons des méthodes de protection de pointe, telles que des protocoles
                    de chiffrement et des outils de détection de fraude.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    Est-ce que MooviCar vend mes informations à des tiers ?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Non, nous nous sommes engagés à ne pas vendre vos informations personnelles à
                    des tiers.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    Combien de temps MooviCar garde mes informations personnelles ?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Nous conservons vos informations tant que vous avez un compte, mais certaines
                    données peuvent être conservées après suppression de compte si la loi l'exige ou
                    pour des raisons de sécurité.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEight">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEight"
                    aria-expanded="false"
                    aria-controls="collapseEight"
                  >
                    Comment puis-je rechercher ou contrôler les informations collectées par MooviCar
                    à mon sujet ?
                  </button>
                </h2>
                <div
                  id="collapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEight"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Vous pouvez modifier ou supprimer vos informations à tout moment via les
                    paramètres de votre compte ou en nous contactant directement.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-div">
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNine">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNine"
                    aria-expanded="false"
                    aria-controls="collapseNine"
                  >
                    Si j'ai d'autres questions, qui dois-je contacter ?
                  </button>
                </h2>
                <div
                  id="collapseNine"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingNine"
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body">
                    Vous pouvez nous contacter via notre adresse dédiée aux questions de
                    confidentialité : privacy@moovicar.com.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <Link className="btn btn-outline-lg mb-2" to="/help">
            Voir le centre d'aide <i className="bi bi-arrow-right-circle h5"></i>
          </Link>
        </div>
        <hr
          style={{
            border: '1px solid #ff6600',
            width: '100%',
            margin: '20px 0', // Pas de margin auto pour éviter la centration
          }}
        />{' '}
      </div>
    </section>
  );
}

export default Privacy;
